import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useTheme } from '../context/ThemeContext';

const { FiSun, FiMoon, FiMonitor } = FiIcons;

const ThemeToggle = () => {
  const { theme, changeTheme } = useTheme();

  const themes = [
    { key: 'light', icon: FiSun, label: 'Claro' },
    { key: 'system', icon: FiMonitor, label: 'Sistema' },
    { key: 'dark', icon: FiMoon, label: 'Oscuro' }
  ];

  const currentIndex = themes.findIndex(t => t.key === theme);
  const nextTheme = themes[(currentIndex + 1) % themes.length];

  return (
    <motion.button
      onClick={() => changeTheme(nextTheme.key)}
      className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      title={`Cambiar a modo ${nextTheme.label.toLowerCase()}`}
    >
      <SafeIcon icon={themes[currentIndex].icon} className="w-5 h-5" />
    </motion.button>
  );
};

export default ThemeToggle;